import { ProfitType } from 'pages/QuoteView/Quoting/RequestQuickQuote/types';

// Which default the backend used for suggestedMargin. Freight uses the first three;
// auto transport can also raise the margin to a minimum or a profit floor.
export enum MarginBasis {
  UserDefault = 'user_default',
  Configured = 'configured',
  Fallback = 'fallback',
  MinPercent = 'min_percent',
  ProfitFloor = 'profit_floor',
}

export type SourceRow = {
  label: string;
  buy: number;
  low: number;
  high: number;
  // Only set for sources that send a confidence score, like Triumph or Super Dispatch.
  confidenceLevel?: number;
  // isLowConfidence means a quote's confidence is below threshold and excluded from the avg. calculation
  isLowConfidence?: boolean;
};

export type CalculationStep = {
  id: string;
  title: string;
  description: string;
};

export type Suggestion = {
  transportType: string;
  targetBuy: number;
  buyLow: number;
  buyHigh: number;
  suggestedMargin: number;
  // Amount when the rep's or company's default is flat dollars; otherwise a percent.
  suggestedMarginType?: ProfitType;
  marginBasis?: MarginBasis;
  // Distance used for $/mi display only (calculator owns live distance).
  distanceMiles: number;
  // Used as metric for the QQ Coach's Confidence estimation
  spreadPercent: number;
  sources: SourceRow[];
  // Every source was below the confidence threshold, so Kit built the buy from them anyway.
  isLowConfidence?: boolean;
  // Auto transport only: the opening paragraph written by the backend.
  summary?: string;
  // Auto transport only: steps written by the backend, shown instead of the freight steps.
  calculationSteps?: CalculationStep[];
};
